import { FrameworkConfiguration, PLATFORM } from 'aurelia-framework';

//Declaring strcturedClone globally so that it doesn't thorw an false errors
declare global {
    function structuredClone<T>(value: T): T;
}

export function configure(frameworkConfiguration: FrameworkConfiguration) {

    //Load global resources
    // frameworkConfiguration.plugin(PLATFORM.moduleName('./helpers/update-interval.behavior'));
    frameworkConfiguration.globalResources([
        //Load helpers
		PLATFORM.moduleName('./helpers/dirty-binding'),
		PLATFORM.moduleName('./helpers/async-binding'),

		//Load custom attributes
		PLATFORM.moduleName('./attributes/lookup-property.attribute'),
		PLATFORM.moduleName('./attributes/async-click-with-loading'),
		PLATFORM.moduleName('./attributes/image-downloader'),
		PLATFORM.moduleName('./attributes/animatable-js-if'),

		//Load converters
		PLATFORM.moduleName('./converters/active-filter.converter'),
		PLATFORM.moduleName('./converters/html-sanitize.converter'),
		PLATFORM.moduleName('./converters/number-format.converter'),
		PLATFORM.moduleName("./converters/boolean-inverse"),

        //Load components
		PLATFORM.moduleName('./components/comp-loader/comp-loader'),
		PLATFORM.moduleName('./components/comp-icon/comp-icon'),
		PLATFORM.moduleName('./components/comp-notify/comp-notify'),
		PLATFORM.moduleName('./components/comp-field/comp-field'),
		PLATFORM.moduleName('./components/comp-check-box/comp-check-box'),
		PLATFORM.moduleName('./components/comp-carousel/comp-carousel'),
		PLATFORM.moduleName('./components/comp-radio-button/comp-radio-button'),
		PLATFORM.moduleName('./components/comp-button-dropdown/comp-button-dropdown'),
		PLATFORM.moduleName('./components/comp-text-box/comp-text-box'),
		PLATFORM.moduleName('./components/comp-text-box/input-formatter-value-converter'),
		PLATFORM.moduleName('./components/comp-entity-finder/comp-entity-finder'),
		PLATFORM.moduleName('./components/comp-tooltip/comp-tooltip'),
		PLATFORM.moduleName('./components/comp-button/comp-button'),
		PLATFORM.moduleName('./components/comp-list-menu/comp-list-menu'),
		PLATFORM.moduleName('./components/comp-date-picker/comp-date-picker'),
		PLATFORM.moduleName('./components/comp-rich-text-editor/comp-rich-text-editor'),
		PLATFORM.moduleName('./components/comp-data-grid/comp-data-grid'),
		PLATFORM.moduleName('./components/comp-pagination/comp-pagination'),
		PLATFORM.moduleName('./components/comp-notification/comp-notification'),
		PLATFORM.moduleName('./components/comp-file-uploader/comp-file-uploader'),
		PLATFORM.moduleName('./components/comp-dynamic-view/comp-dynamic-view'),
		PLATFORM.moduleName('./components/comp-dialog/comp-dialog'),
		PLATFORM.moduleName('./components/comp-combo-box/comp-combo-box'),
		PLATFORM.moduleName('./components/comp-lookup-control/comp-lookup-control'),
		PLATFORM.moduleName('./components/comp-text-area/comp-text-area'),
		PLATFORM.moduleName('./components/comp-radio-button-lookup/comp-radio-button-lookup'),
		PLATFORM.moduleName('./components/comp-field/comp-field'),
		PLATFORM.moduleName('./components/comp-collapsable/comp-collapsable'),
		PLATFORM.moduleName('./components/comp-adorner/comp-adorner'),
		PLATFORM.moduleName('./components/comp-adorner/comp-adorned'),
		PLATFORM.moduleName('./components/comp-tabs/comp-tabs'),
		PLATFORM.moduleName('./components/comp-multi-select-lookup-control/comp-multi-select-lookup-control'),
		PLATFORM.moduleName('./components/comp-multi-select-combo-box/comp-multi-select-combo-box'),
		PLATFORM.moduleName('./components/comp-tabs-menu/comp-tabs-menu'),
		PLATFORM.moduleName('./components/comp-toggle/comp-toggle'),
		PLATFORM.moduleName('./components/comp-section-expander/comp-section-expander'),
		PLATFORM.moduleName('./components/comp-safety-score/comp-safety-score'),
		PLATFORM.moduleName('./components/comp-switch/comp-switch'),
		PLATFORM.moduleName('./components/comp-ghg-rating/comp-ghg-rating'),
		PLATFORM.moduleName('./components/comp-banner-crew-welfare/comp-banner-crew-welfare'),
		PLATFORM.moduleName('./components/comp-banner-inspection/comp-banner-inspection'),
		PLATFORM.moduleName('./components/comp-due-diligence-status/comp-due-diligence-status'),
		PLATFORM.moduleName('./components/comp-object-viewer/comp-object-viewer'),
		PLATFORM.moduleName('./components/comp-pdf-viewer/comp-pdf-viewer'),
		PLATFORM.moduleName('./components/comp-image-viewer/comp-image-viewer'),
		
		//Filters
		PLATFORM.moduleName('./components/comp-mobile-filter/comp-mobile-filter'),
		PLATFORM.moduleName('./components/comp-mobile-filters/comp-mobile-filters'),
		PLATFORM.moduleName('./components/comp-desktop-filter/comp-desktop-filter'),
		PLATFORM.moduleName('./components/comp-desktop-filter/dropdowns/comp-checked-list-selector/comp-checked-list-selector'),
		PLATFORM.moduleName('./components/comp-desktop-filter/dropdowns/comp-date-range-selector/comp-date-range-selector'),

		//Load partials
		PLATFORM.moduleName('./partials/partial-attachment-viewer/partial-attachment-viewer'),
		PLATFORM.moduleName('./partials/partial-layout/partial-layout'),
		PLATFORM.moduleName('./partials/partial-tabbed-entity-item/partial-tabbed-entity-item'),
		PLATFORM.moduleName('./partials/partial-upload-psc-files/partial-upload-psc-files')
    ]);
 }
